// extracted by mini-css-extract-plugin
export default {"wrapper":"TokenLogin_wrapper__-g3BG","title":"TokenLogin_title__D6pR3"};